import React,{Component} from 'react';
import connect from "react-redux/es/connect/connect";
import OrderAccepted from "./orderaccepted";
import OrderDeclined from "./orderdeclined";
class PayByCredits extends Component {

  constructor(props) {
    super(props);
    this.state = {

    };
  }

  getTranslation(key)
  {
    return this.props.WebPage.Translations[key];
  }

  render() {
    debugger;
    console.log(this.props.Billing.CheckOrder);
    return (
      <React.Fragment>
        {!this.props.Billing.CheckOrder.Loaded &&
        <React.Fragment>
          <div className="large-text">{this.getTranslation("dash.pleasewait")}</div>
          <p style={{width: "100%", display: "flex", alignContent: "center", justifyContent: "center"}}>
            <img src="/imgs/loader.gif" width={"100px"} height={"100px"} alt={"Loading"}/>
          </p>

        </React.Fragment>
        }
        {this.props.Billing.CheckOrder.Loaded &&
        <React.Fragment>
          {this.props.Billing.CheckOrder.Result.Result.Approved &&
          <OrderAccepted
            OrderId={this.props.Billing.CheckOrder.Result.Result.TransactionId} TransactionId={""}
          />
          }
          {!this.props.Billing.CheckOrder.Result.Result.Approved &&
          <OrderDeclined
            Message = {this.props.Billing.CheckOrder.Result.Result.Message}
            handleBackToBilling = {(e) => {this.handleBackToBilling(e)}}
          />
          }
        </React.Fragment>
        }
        <div className="secure-div">
          <img src="/imgs/billing/secure-site.png" alt="" style={{margin: "50px auto"}}/>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    WebPage: state.Website,
    Ads: state.Ads,
    Billing: state.Billing
  };
}

export default connect(mapStateToProps)(PayByCredits);




